import { Body, MaterialUICore, axiomTokens } from '@iclinic/design-system';

const { styled } = MaterialUICore;
const { color } = axiomTokens;

export const DescriptionText = styled(Body)({
  color: color.typeface.smooth,
});
